export const HISTORY_PUSH = '[HISTORY] HISTORY_PUSH';
export const HISTORY_REPLACE = '[HISTORY] HISTORY_REPLACE';
export const push = payload => ({type: HISTORY_PUSH, payload});
export const replace = payload => ({type: HISTORY_REPLACE, payload});